<template>
  <div class="header fl-tc fl-lb">
    <div class="fl-tc fl-lb" style="width: 1200px;margin: 0 auto">
      <div class="fl-tc" style="width: 370px;">
        <img src="@/assets/img/logo.png" class="h66">
      </div>
      <div class="fl-tc gp60">
        <div class="search-wrap fl-cc h32">
          <div class="input-wrap h32">
            <img src="@/assets/img/icon5.png" class="search-img">
            <input type="text" class="search-input h32 w100 b0" maxlength="50" v-model="state.title">
          </div>
          <div class="search-btn fl-cc fs16 h32 color-F1F7FD bg-007AFF cp" @click="setTitle">搜索</div>
        </div>
        <div class="login-wrap">
          <template v-if="!user">
            <div class="login-btn fs16 color-007AFF fl-cc cp" @click="toggleLogin(1)">登录</div>
          </template>
          <template v-else>
            <div class="fl-tc">
              <img :src="user.avatar" class="avatar br50 cp" @click="goUrl('/personal');">
              <div class="nickname fs16 ml8 mr24 cp" @click="goUrl('/personal');">{{ user.nickname }}</div>
              <img src="@/assets/img/icon8.png" class="logout cp" @click="logout">
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
  <div class="menu-wrap h48 bg-007AFF w100 fl-cc">
    <template v-for="menu in routes">
      <router-link :to="menu.path" class="t-white fs18 fl-cc" :class="{active:router.currentRoute.value.path == menu.path}" v-if="!menu.isHide">{{menu.title}}</router-link>
    </template>
  </div>
  <a-modal :title="false" :closable="false" :maskClosable="false" :footer="null" centered width="380px" class="login-modal" v-model:open="state.mobileLogin">
    <div class="fl-cc fl-c">
      <div class="fl-tc mt40" style="width: 270px;">
        <img src="@/assets/img/logo.png" class="w100">
      </div>
      <div class="login-input-wrap fl-tc gp8 pl12 mt24">
        <img src="@/assets/img/icon1.png">
        <input type="text" placeholder="请输入手机号" class="b0 w100" maxlength="11" v-model="state.param.mobile"  style="width: 100%">
      </div>
      <div class="login-input-wrap fl-tc gp8 pl12 mt24" v-if="[3,4].includes(state.modalType)">
        <img src="@/assets/img/icon2.png">
        <input type="text" placeholder="请输入验证码" class="code b0" maxlength="6" v-model="state.param.captcha">
        <div class="get-code fs14 color-007AFF fl-cc ml62 mr6 cp" @click="sendCode" :class="{disabled:state.captchaText != '获取验证码'}">{{state.captchaText}}</div>
      </div>
      <div class="login-input-wrap fl-tc gp8 pl12 mt24" v-if="[2,3,4].includes(state.modalType)">
        <img src="@/assets/img/icon2.png">
        <input type="password" placeholder="请输入密码" class="code b0" v-model="state.param.password"  style="width: 100%">
      </div>
      <div class="login-input-wrap fl-tc gp8 pl12 mt24" v-if="[3,4].includes(state.modalType)">
        <img src="@/assets/img/icon2.png">
        <input type="password" placeholder="请再次输入密码" class="code b0" v-model="state.param.password2" style="width: 100%">
      </div>
      <div class="fs14 fl-le  color-007AFF mtb16 cp" style="width: 284px;" v-if="state.modalType == 2" @click="toggleLogin(4)">忘记密码?</div>
      <div class="model-login-btn fl-cc fs16 color-F8F8F8 cp" @click="login" v-if="state.modalType == 2">登录</div>
      <div class="model-login-btn mt32 fl-cc fs16 color-F8F8F8 cp" @click="register" v-if="state.modalType == 3">注册</div>
      <div class="model-login-btn mt32 fl-cc fs16 color-F8F8F8 cp" @click="register" v-if="state.modalType == 4">提交</div>
      <div class="agree-wrap fl-tc gp16 mt17" v-if="state.modalType != 4">
        <a-checkbox v-model:checked="state.agree"></a-checkbox>
        <div class="fs12">
          <span>同意</span>
          <span class="color-007AFF ml6 cp" @click="state.showModal=true">《登录用户协议》</span>
        </div>
      </div>
      <div class="wechat-wrap bg-F8F8F8 fl-cc w100 mt48 gp30 h56">
        <a class="fl-cc gp6 cp" href="https://jinshuju.com/f/Prykdb" target="_blank">
          <div class="fs14">单位注册</div>
        </a>
        <div class="fl-cc gp6 cp" @click="toggleLogin(3)" v-if="[2,4].includes(state.modalType)">
          <img src="@/assets/img/icon4.png" style="width: 28px;height: 28px">
          <div class="fs14">注册</div>
        </div>
        <div class="fl-cc gp6 cp" @click="toggleLogin(2)" v-if="[3,4].includes(state.modalType)">
          <img src="@/assets/img/pwd.png" style="width: 28px;height: 28px">
          <div class="fs14">密码登录</div>
        </div>
        <div class="fl-cc gp6 cp" @click="toggleLogin(1)">
          <img src="@/assets/img/icon6.png">
          <div class="fs14">微信登录</div>
        </div>
      </div>
    </div>
  </a-modal>
  <a-modal :title="false" :closable="false" :maskClosable="false" :footer="null" centered width="380px" class="login-modal" v-model:open="props.wxLogin">
    <div class="fl-cc fl-c">
      <a-spin v-model:spinning="state.qrCodeLoading">
        <div class="code-wrap" id="code-wrap" style="width: 300px;height: 400px">
        </div>
      </a-spin>
      <div class="wechat-wrap bg-F8F8F8 fl-cc w100 gp30 h56">
        <a class="fl-cc gp6 cp" href="https://jinshuju.com/f/Prykdb" target="_blank">
          <div class="fs14">单位注册</div>
        </a>
        <div class="fl-cc gp6 cp" @click="toggleLogin(3)">
          <img src="@/assets/img/icon4.png" style="width: 28px;height: 28px">
          <div class="fs14">注册</div>
        </div>
        <div class="fl-cc gp6 cp" @click="toggleLogin(2)">
          <img src="@/assets/img/pwd.png" style="width: 28px;height: 28px">
          <div class="fs14">密码登录</div>
        </div>
      </div>
    </div>
  </a-modal>
  <agreement :show-modal="state.showModal" :type="2" @update:showModal="state.showModal=false" @update:agree="updateAgree" />
</template>

<script setup>
import {reactive, inject, toRefs, onMounted, onBeforeUnmount, watch, ref, computed} from "vue";
import { useRouter } from "vue-router";
import { routes } from '@/router';
import {getRequest, goUrl,baseUrl} from '@/assets/js/common';
import { message } from 'ant-design-vue';
import agreement from "@/components/agreement.vue";
const router = useRouter();
const emit = defineEmits(['setTitle','update:wxLogin']);
import { useStore } from 'vuex';
const store = useStore()
const props = defineProps({
  wxLogin: {
    type: Boolean,
    default: false,
  },
});
const state = reactive({
  mobileLogin:false,
  modalType:2,
  agree:false,
  qrCode:'',
  qrCodeLoading:true,
  wechatLoginUrl :'',
  title:'',
  param:{mobile:'',captcha:'',password:'',password2:''},
  captchaText:'获取验证码',
  showModal:false,
});
const user = computed(() => {
  return JSON.parse(store.state.user);
})
//密码登录
const login = () => {
  if(state.param.mobile.trim() === ''){
    message.info('请输入手机号码');
    return;
  }
  if(state.param.mobile.trim().length != 11){
    message.info('请输入正确手机号码');
    return;
  }
  if(state.param.password === ''){
    message.info('请输入密码');
    return;
  }
  if(!state.agree){
    message.info('请先勾选协议');
    return;
  }
  getRequest('/user/login', state.param)
      .then(res => {
        if(!res.code){
          message.info(res.msg);
          return;
        }
        sessionStorage.setItem('token',res.data.token)
        store.dispatch('getUserInfo').then(() => {
          hideMobileLogin(false);
          window.location.reload();
        });
      })
      .catch(error => {
      }).finally(() => {
  });
}
//注册
const register = () => {
  if(state.param.mobile.trim() === ''){
    message.info('请输入手机号码');
    return;
  }
  if(state.param.mobile.trim().length != 11){
    message.info('请输入正确手机号码');
    return;
  }
  if(state.param.captcha.trim() === ''){
    message.info('请输入验证码');
    return;
  }
  if(state.param.password === ''){
    message.info('请输入密码');
    return;
  }
  if(state.param.password2 === ''){
    message.info('请再次输入密码');
    return;
  }
  if(state.param.password !== state.param.password2){
    message.info('两次密码不一致');
    return;
  }
  if(state.modalType == 3 && !state.agree){
    message.info('请先勾选协议');
    return;
  }
  let url = '/user/register';
  if(state.modalType == 4){
    url = '/user/resetpwd';
  }
  getRequest(url, state.param)
      .then(res => {
        if(!res.code){
          message.info(res.msg);
          return;
        }
        if(state.modalType == 3){
          sessionStorage.setItem('token',res.data.token)
          store.dispatch('getUserInfo').then(() => {
            hideMobileLogin(false);
            window.location.reload();
          });
        }
        if(state.modalType == 4){
          state.param.mobile = '';
          state.param.captcha = '';
          state.param.password = '';
          state.param.password2 = '';
          message.info('重置密码成功');
          setTimeout(()=>{
            state.modalType = 2;
          },2000)
        }
      })
      .catch(error => {
      }).finally(() => {
  });
}
//退出
const logout = () => {
  getRequest('/user/logout')
      .then(res => {
        sessionStorage.removeItem('token')
        store.dispatch('getUserInfo').then(() => {
          window.location.reload();
        });
      })
      .catch(error => {
      }).finally(() => {
  });
}
//切换登录
const toggleLogin = async (type) => {
  if(type == 1){
    if(state.qrCodeLoading){
      await loadScript();
      setTimeout(() => { // 延迟确保微信JS完全初始化
        initWechatLogin();
      }, 500);
    }
    hideMobileLogin(false);
    emit('update:wxLogin',true);
  }else{
    state.modalType = type;
    hideMobileLogin(true);
    emit('update:wxLogin',false);
  }
}
//发送验证码
const sendCode = () => {
  if(state.param.mobile.trim() === ''){
    message.info('请输入手机号码');
    return;
  }
  if(state.param.mobile.trim().length != 11){
    message.info('请输入正确手机号码');
    return;
  }
  let event = 'register';
  if(state.modalType == 4){
    event = 'resetpwd';
  }
  getRequest('/sms/send', {mobile:state.param.mobile,event:event})
      .then(res => {
        if(!res.code){
          message.info(res.msg);
          return;
        }
        message.info('发送成功');
        codeText();
      })
      .catch(error => {
        message.error('发送失败');
      }).finally(() => {
  });
}
//验证码倒计时
const codeText = () => {
  let timer = null;
  let tNum = 60;
  timer = setInterval(()=>{
    if(tNum === 1){
      clearInterval(timer);
      state.captchaText = '获取验证码';
    }else {
      tNum --;
      state.captchaText = tNum > 9 ? tNum + '' : '0'+ tNum;
    }
  },1000);
}
//发送搜索课程标题
const setTitle = () => {
  emit('setTitle', state.title);
}
//隐藏登录弹层
const hideMobileLogin = (value) => {
  state.mobileLogin = value;
}
//协议
const updateAgree = (res) => {
  state.agree = res.agree;
}
//回车登录
// const handleEnterKey = (e) => {
//   if (e.key === 'Enter') {
//     if(showLogin.value){
//       login();
//     }
//   }
// }
const loadScript = ()=> {
  console.log('开始加载微信脚本');
  return new Promise((resolve, reject) => {
    if (window.WxLogin) {
      console.log('微信脚本已存在，跳过重复加载');
      return resolve();
    }
    const script = document.createElement('script');
    script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
    script.onload = () => {
      console.log('微信脚本加载成功');
      resolve();
    };
    script.onerror = (err) => {
      console.error('微信脚本加载失败', err);
      reject(err);
    };
    document.body.appendChild(script);
  });
}
var stateNumber = Math.random().toString(36).substring(2);
const initWechatLogin = () => {
  console.log('初始化微信登录', window.WxLogin);
  if (!window.WxLogin) {
    console.error('WxLogin 未定义！');
    return;
  }
  // 创建一个隐藏的容器用于预先加载二维码
  const preloadContainer = document.createElement('div');
  preloadContainer.style.position = 'absolute';
  preloadContainer.style.left = '-9999px';
  preloadContainer.style.top = '-9999px';
  preloadContainer.id = 'preload-wechat-qrcode';
  document.body.appendChild(preloadContainer);

  new window.WxLogin({
    self_redirect:false,
    id: "preload-wechat-qrcode",
    appid: "wxd7ef42658c5797f6",
    scope: "snsapi_login",
    fast_login:0,
    // stylelite:1,
    href:baseUrl+'/wechat-qrcode.css',
    redirect_uri:encodeURIComponent(baseUrl+"/addons/third/index/callback/platform/wechat"),
    state: stateNumber,
    onReady: function(isReady){
      console.log('isReady',isReady);
      if(isReady){
        state.qrCodeLoading = false;
      }
    }
  });
}

// 将二维码移动到弹窗容器
const moveQrCodeToModal = () => {
  const preloadContainer = document.getElementById('preload-wechat-qrcode');
  const targetContainer = document.getElementById('code-wrap');
  if (preloadContainer && targetContainer && targetContainer.children.length === 0) {
    // 移动所有子元素到目标容器
    while (preloadContainer.firstChild) {
      targetContainer.appendChild(preloadContainer.firstChild);
    }
    // 移除预加载容器
    document.body.removeChild(preloadContainer);
  }
}
let timer = null;

watch(
    () => props.wxLogin,
    (newVal) => {
      if (newVal) {
        // 弹窗显示时，检查是否需要移动二维码
        setTimeout(() => { // 延迟确保微信JS完全初始化
          moveQrCodeToModal();
        }, 50);
        startPolling();
      } else {
        stopPolling();
      }
    }
);

function startPolling() {
  if (timer) return; // 防止重复开启
  timer = setInterval(() => {
    getRequest('/user/getUserInfo')
        .then(res => {
          if(res.code == 1000){
            stopPolling();
            goUrl('/bindmobile')
            return;
          }
          if(!res.code || !res.data){
            return;
          }
          stopPolling();
          sessionStorage.setItem('token',res.data.token)
          store.dispatch('getUserInfo').then(() => {
            emit('update:wxLogin',false);
            // window.location.reload();
          });
        })
        .catch(error => {
        }).finally(() => {
    });
  }, 1000);
}

function stopPolling() {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
}

onMounted(async() => {
  // window.addEventListener('keydown', handleEnterKey)
  if(!user.value){
    await loadScript();
    setTimeout(() => { // 延迟确保微信JS完全初始化
      initWechatLogin();
    }, 500);
    startPolling();
  }
})

onBeforeUnmount(() => {
  // window.removeEventListener('keydown', handleEnterKey)
  if(!user.value){
    stopPolling();
  }
})
</script>
<style>
.login-modal .ant-modal-content{
  padding: 0!important;
}
</style>
<style scoped>
.header{
  width: 100%;
  height: 110px;
  background: url("@/assets/img/icon3.png") no-repeat center;
  background-size: cover;
}
.input-wrap{
  width: 216px;
  position: relative;
}
.input-wrap input{
  border: 1px solid #CCCCCC;
  text-indent: 30px;
}
.search-img{
  position: absolute;
  top: 6px;
  left: 8px;
}
.search-btn{
  width: 80px;
}
.login-btn{
  width: 80px;
  height: 32px;
  border: 1px solid #007AFF;
}
.menu-wrap a{
  width: 240px;
  height: 48px;
}
.menu-wrap a.active,.menu-wrap a:hover{
  font-weight: bold;
  background: rgba(255,255,255,0.2);
}
.login-input-wrap{
  width: 284px;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #DDDDDD;
}
.login-input-wrap .code{
  width: 92px;
}
.get-code{
  width: 86px;
  height: 28px;
  background: rgba(0,122,255,0.06);
}
.model-login-btn{
  width: 284px;
  height: 40px;
  background: #007AFF;
}

.login-wrap .avatar{
  width: 44px;
  height: 44px;
}
</style>
